import i18next from 'i18next';
import { RefObject, useEffect } from 'react';

import * as styles from '../../styles';

interface Props {
    center: LatLng;
    myLocation: LatLng;
    zoom: number
    mapRef: RefObject<inavi.maps.Map|null>
    setIsMapLoad: (isMapLoad: boolean) => void
    isMapLoad: boolean
    id: string,
    onBoundChange?: (props:{neLon: number, neLat: number, swLon: number, swLat: number, lat: number, lng: number}) =>void;
    showMyLocation?: boolean;
}

const locationIcon = `<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15 0.9375C21.2134 0.9375 26.25 5.97411 26.25 12.1875C26.25 14.0436 25.5974 16.4508 24.791 17.9883C22.7346 21.9084 15 28.125 15 28.125C15 28.125 7.2654 21.9084 5.20898 17.9883C4.4026 16.4508 3.75 14.0436 3.75 12.1875C3.75 5.97411 8.78661 0.9375 15 0.9375ZM15 8.4375C12.9289 8.4375 11.25 10.1164 11.25 12.1875C11.25 14.2586 12.9289 15.9375 15 15.9375C17.0711 15.9375 18.75 14.2586 18.75 12.1875C18.75 10.1164 17.0711 8.4375 15 8.4375Z" fill="#CB2B2B"/>
<circle cx="15" cy="12.5" r="5" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M15 1.25C8.78661 1.25 3.75 6.2866 3.75 12.5C3.75 14.3562 4.40245 16.7636 5.20887 18.301C7.26529 22.2211 15 28.4375 15 28.4375C15 28.4375 22.7347 22.2211 24.7911 18.301C25.5975 16.7636 26.25 14.3562 26.25 12.5C26.25 6.2866 21.2134 1.25 15 1.25Z" stroke="white" stroke-width="2" stroke-linejoin="round"/>
</svg>
`;

function useMap({
    center, zoom, mapRef, isMapLoad, setIsMapLoad, id, onBoundChange, showMyLocation,
    myLocation,
}:Props) {
    const onMoveEnd = () => {
        const {
            south, east, west, north,
        } = mapRef.current!.getBounds();
        const { lat, lng } = mapRef.current!.getCenter();
        onBoundChange?.({
            neLon: east,
            neLat: north,
            swLat: south,
            swLon: west,
            lat,
            lng,
        });
    };
    const registerMapCallback = () => {
    // @ts-ignore
        window.initMap = () => {
            try {
                (mapRef.current as any) = new inavi.maps.Map({
                    center: [center.lng, center.lat],
                    container: id,
                    disableDefaultUI: true,
                    zoom,
                });
                setIsMapLoad(true);
                if (onBoundChange) {
          mapRef.current!.on('moveend', onMoveEnd);
                }
                onMoveEnd();
            } catch (e) {
                console.error(e);
                console.warn('map not initialized');
            }
        };
    };
    useEffect(registerMapCallback, [center.lat, center.lng, mapRef, setIsMapLoad, zoom]);

    useEffect(() => {
        if (!isMapLoad) {
            if ('initMap' in window) {
                // @ts-ignore
                window.initMap();
            }
        }
    }, [isMapLoad]);

    // 내 위치 마커 표시
    useEffect(() => {
        if (isMapLoad && showMyLocation && mapRef.current) {
            const icon = document.createElement('div');
            icon.className = styles.location;
            icon.innerHTML = locationIcon;
            const text = document.createElement('span');
            text.className = styles.locationText;
            text.innerText = i18next.t('map.myLocation', { ns: 'common' });
            icon.append(text);
            const marker = new inavi.maps.Marker({
                position: [myLocation.lng, myLocation.lat],
                icon,
            });
            marker.setMap(mapRef.current);
        }
    }, [isMapLoad, showMyLocation, myLocation, mapRef]);

    // 중앙 위치 변경
    useEffect(() => {
        if (mapRef.current && center) {
            mapRef.current.setCenter(center);
            onMoveEnd();
        }
    }, [center]);
}

export default useMap;
